<template>
    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" :class="{ 'modal-dialog-centered': centered }"
             role="document">
            <div class="modal-content">
                <div v-if="showHeader" class="modal-header">
                    <slot name="header">
                        <h5 class="modal-title">Modal title</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        ...
                    </slot>
                </div>

                <div v-if="showFooter" class="modal-footer">
                    <slot name="footer">
                        <button type="button" class="btn btn-primary">Save changes</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        props: {
            showHeader: {
                type: Boolean,
                default: true
            },
            showFooter: {
                type: Boolean,
                default: true
            },
            centered: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            let isShowing = false;
            const modalUrlHash = '#modal';
            $(this.$el)
                .on('show.bs.modal', () => {
                    isShowing = true;
                    window.history.pushState(null, 'Modal', '#modal');
                })
                .on('hide.bs.modal', () => {
                    isShowing = false;
                    if (window.location.hash === modalUrlHash) {
                        window.history.back()
                    }
                });
            window.addEventListener('popstate', () => {
                if (isShowing) {
                    this.hide()
                }
            })
        },
        methods: {
            show() {
                this.call('show')
            },
            hide() {
                this.call('hide')
            },
            toggle() {
                this.call('toggle')
            },
            call(method) {
                $(this.$el).modal(method)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal.vue